import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import InputUI from '../../../components/UI/InputUI';
import BackButton from '../../../components/UI/BackButton';
import TruckKanbanService from '../../../services/TruckKanbanService';
import { InfiniteScroll } from '../../../components/UI/ComponentsUI';
import { onValueChange } from "../../../utils/handleChangeHooks";
import { translate, isNullOrEmpty, showMessageToastCustom, downloadFile } from '../../../utils/util';
import { Button, Title, ScannerCode, Fab, Modal } from '../../../components/UI/ComponentsUI';
import ItemsXdSelected from './ItemsXdSelect'
import useStateWithPromise from '../../../utils/useEffectUpdate';
import ItemSpaceXD from './ItemSpaceXD';
import ConfirmModal from '../../../components/UI/ConfirmModal';

const SpaceXD = (props) => {
    const filterDefault = {
        cim: '',
        labelId: 0,
        partNumberCode: '',
        shed: '',
        shedTruckKanban: '',
        mvm: '',
        truckKanban: true,
        dispatched: false,
        journey: '',
        dateStart: '',
        dateEnd: '',
        changeLocation: false
    }
    const messageModal = useRef();
    const [data, setData] = useState([]);
    const [openItensModal, setOpenItensModal] = useStateWithPromise(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [result, setResult] = useStateWithPromise();
    const [refresh, setRefresh] = useStateWithPromise(false);
    const [filterSearch, setFilterSearch] = useState(filterDefault)

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    useEffect(() => {
        if (currentPage > 0) {
            onClickButton(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);


    useEffect(() => {
        if (result?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(result.items);
            } else {
                setData((prevState) => ([...prevState, ...result.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [result?.items]);

    useEffect(() => {
        props.clearLabel();
        onClickButton(false);
        document.getElementById('cim').focus();

        // eslint-disable-next-line
    }, []);

    const onClickButton = (click) => {
        var currentPageList = currentPage;
        if (click) {
            //props.clearLabel();
            currentPageList = 0;
            setCurrentPage(0);
            setResult();
            setData([]);
        }

        if (!isNullOrEmpty(filterSearch.cim)) {
            onQrCodeReadHandler(filterSearch.cim);
        } else {
            const filterObj = {};
            Object.assign(filterObj, filterSearch);
            filterObj.PageSize = 20;
            filterObj.PageIndex = currentPageList;
            setFilterSearch(filterObj);

            props.getLabelsPaged(
                filterObj,
                (response) => {
                    setResult(response);
                }
            );
        }
    }

    const addLabelMvi = (label) => {
        if (props.labels.find(f => f.id === label.id)) {
            return showMessageToastCustom(translate('warning', 'general'), "Item já adicionado!.", 3000, 'mdi mdi-alert-circle-outline red-text');
        } else {
            props.addLabel(label);
        }
    }

    const addMviItem = (label, event) => {
        if (event.target.checked) {
            onQrCodeReadHandler(label.cim, true);
        }
        else {
            setRefresh(true);
            if (!isNullOrEmpty(label.masterCim)) {
                let listMasterCim = props.labels.filter(l => l.masterCim === label.masterCim);
                listMasterCim.forEach((m) => {
                    props.removeLabel(m);

                })
            }
            else {
                props.removeLabel(label);
            }
            setTimeout(() => { setRefresh(false); }, 50);
        }
    }

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter' && e.target.value && !isNullOrEmpty(e.target.value)) {
            onQrCodeReadHandler(e.target.value, false);
        }
    }

    const onQrCodeReadHandler = (data) => {
        if (!isNullOrEmpty(data)) {
            var cim = "";
            if (data.split('-').length > 1) {
                cim = data.split('-')[1]
            } else {
                cim = data;
            }

            const filterObj = {};
            Object.assign(filterObj, filterSearch);
            filterObj.cim = cim;
            filterObj.mvi = true;

            props.getLabelsCim(
                filterObj,
                (response) => {
                    setFilterSearch({ ...filterDefault });
                    if (!response || response.length === 0) {
                        showMessageToastCustom(translate('general:warning'),
                            translate('item-not-found', 'validations'),
                            4000, 'mdi mdi-alert-circle-outline red-text')
                    } else {
                        setChecked(response);
                    }
                    document.getElementById('cim').focus();

                }
            );
        }
    }

    const setChecked = (labels) => {
        setRefresh(true);
        if (labels) {
            labels.forEach(label => {
                label.qrCode = true;
                const addItem = {
                    partNumberCode: label.receipt.partNumberCode,
                    partNumberDescription: label.receipt.partNumberDescription,
                    mvmNumber: label.receipt.mvmNumber,
                    ...label
                }
                addLabelMvi(addItem);
            });

            let newData = data;

            labels.forEach((label) => {
                let item = data.find(d => d.id === label.id);
                if (item) {
                    item.qrCode = true;
                }
                else {
                    newData.push(label);
                }
            });
            const newResult = {
                items: newData,
                pageIndex: result.pageIndex,
                pageSize: result.pageSize,
                totalCount: newData.length,
                totalPages: result.totalPages
            }
            setResult({ ...newResult }).then(() => {
                setRefresh(false)
                // setRefresh(false).then(() => {
                //     var label = labels[0];

                //     if (label) {
                //         var element = document.getElementById(label.id);
                //         if (element) {
                //             element.scrollIntoView({
                //                 behavior: 'smooth'
                //             });
                //             element.style.backgroundColor = "#2196f3"
                //             setTimeout(() => {
                //                 element.style.backgroundColor = "white"
                //             }, 1500);
                //         }
                //     }
                // });
            });
        }
    }

    const validateCreateMvi = (callback) => {
        if (props.labels.length === 0) {
            return showMessageToastCustom(translate('warning', 'general'), "Nenhum item selecionado.", 3000, 'mdi mdi-alert-circle-outline red-text');
        }
        else {
            callback();
        }
    }

    const downloadReport = () => {
        props.getReport(
            filterSearch,
            (response) => {
                downloadFile(response, `SpaceXd${Date.now()}.csv`, "data:text/csv", true);
            }
        );
    }

    const renderButtonsMvi = () => {
        return (
            props.labels && props.labels.length > 0 &&
            <div className="row" style={{ paddingTop: '0px' }}>
                <div className="col s6 left">
                    <Button
                        full="true"
                        className="col s6 btn-principal"
                        text={translate('truck-kanban:addMvi')}
                        onClick={() => validateCreateMvi(() => props.history.push({
                            pathname: `./createMvi`,
                            state: { hasJourney: true },
                            ...props
                        }))}
                    />
                </div>
                <div className="col s6 left">
                    <Button
                        full="true"
                        secundary="true"
                        className="col s6 btn-flat"
                        text={translate('truck-kanban:withoutJourney')}
                        onClick={() => { messageModal.current.show() }}
                    />
                </div>

            </div>
        )
    }

    const onCloseModalItems = (clear) => {
        if (clear) {
            props.clearLabel();
            setOpenItensModal(false);
            onClickButton(true);
        } else {
            setRefresh(true);
            setOpenItensModal(false).then(() => {
                setRefresh(false);
            });
        }

    }

    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi-clipboard-list-outline" label={translate('truck-kanban:partnumber-xd-search')} />
            {
                data.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                <i className={`mdi mdi-package-down above-btn`} style={{ cursor: 'pointer' }} onClick={downloadReport} />
            }
            <div className="container s12">
                <div className="card">
                    <div className="card-content" style={{ padding: '5px' }}>
                        <div id="formInput" className="form-group">
                            <div className="row">
                                <div className="input-field no-padding col s11">
                                    <ScannerCode className="mdi mdi-qrcode-scan posfix" onScanner={onQrCodeReadHandler} />
                                    <InputUI
                                        onKeyDown={(e) => handleOnKeyDown(e)}
                                        id="cim"
                                        name="cim"
                                        label={`${translate('truck-kanban:qrCode')}/CIM`}
                                        type="text"
                                        onChange={(evt) => {
                                            if (evt.target.value.length > 9) {
                                                onQrCodeReadHandler(evt.target.value)
                                            }
                                            onChange(evt);
                                        }}
                                        value={filterSearch.cim}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <InputUI
                                        id="mvm"
                                        name="mvm"
                                        label={translate('truck-kanban:mvm')}
                                        type="text"
                                        defaultValue={filterSearch.mvm || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <InputUI
                                        id="journey"
                                        name="journey"
                                        label={translate('truck-kanban:journey')}
                                        type="text"
                                        defaultValue={filterSearch.journey || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <InputUI
                                        id="shedTruckKanban"
                                        name="shedTruckKanban"
                                        label={translate('truck-kanban:shedTruckKanban')}
                                        type="text"
                                        defaultValue={filterSearch.shedTruckKanban || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <InputUI
                                        id="shed"
                                        name="shed"
                                        label={translate('truck-kanban:destination-shed')}
                                        type="text"
                                        value={filterSearch.shed || ''}
                                        onChange={onChange}
                                    />

                                </div>
                                <div className="input-field no-padding col s11">
                                    <InputUI
                                        id="partNumberCode"
                                        name="partNumberCode"
                                        label={translate('truck-kanban:partNumber')}
                                        type="text"
                                        value={filterSearch.partNumberCode || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field padding col s5">
                                    <InputUI
                                        id="dateStart"
                                        name="dateStart"
                                        label={translate('date-start', 'truck-kanban')}
                                        type="date"
                                        value={filterSearch.dateStart}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field padding col s6">
                                    <InputUI
                                        id="dateEnd"
                                        name="dateEnd"
                                        label={translate('date-end', 'truck-kanban')}
                                        type="date"
                                        value={filterSearch.dateEnd}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col s12 left">
                        <Button
                            full="true"
                            className="col s6 btn-principal"
                            text={translate('truck-kanban:search')}
                            onClick={() => onClickButton(true)}
                        />
                    </div>
                </div>
            </div>
            {renderButtonsMvi()}
            <div className="row" style={{ paddingTop: '0px', marginBottom: '0px' }}>
                <div className="subtitle" style={{ float: 'right', margin: '10px' }}>
                    {translate('truck-kanban:records')} : {result?.totalCount || 0}
                </div>
                {
                    props.labels.length > 0 &&
                    <div onClick={() => setOpenItensModal(true)} className="subtitle" style={{ float: 'right', margin: '10px', cursor: 'pointer' }}>
                        Itens Selecionados : {props.labels.length}
                    </div>
                }
            </div>
            <div className="container-fluid" style={{ marginTop: '0px', paddingBlockEnd: '50px' }}>
                <div id="listItemSpaceXD">
                    {
                        !refresh &&
                        <InfiniteScroll
                            hasMore={currentPage < result?.totalPages ? true : false}
                            page={result?.totalPages}
                            current={{ currentPage, setCurrentPage }}
                            data={
                                data.map((item, index) => {
                                    return (
                                        <ItemSpaceXD
                                            key={`${index}-pgtk`}
                                            item={item}
                                            addMviItem={addMviItem}
                                            refreshComponent={() => {
                                                props.clearLabel();
                                                onClickButton(true);
                                            }} />
                                    );
                                })
                            }
                        />
                    }

                </div>
            </div>
            <ConfirmModal
                ref={messageModal}
                id="messageModal"
                data={{ title: translate('validations:attention'), message: "Você está eliminando um item do XD sem enviar ao Aviso de Embarque. Deseja continuar?" }}
                onConfirm={() => validateCreateMvi(() => props.history.push({
                    pathname: `./createMvi`,
                    state: { hasJourney: false },
                    ...props
                }))}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
            <Modal
                open={openItensModal}
                id="ModalReceiptQuantity"
                content="Items Selecionados XD"
                children={<ItemsXdSelected />}
                dismissible={false}
                onConfirm={() => onCloseModalItems(false)}
                onCancel={() => onCloseModalItems(true)}
                btnCancel="Limpar"
                btnConfirm="Fechar"
            />
            {
                props.labels && props.labels.length > 0 &&
                <Fab
                    buttons={[
                        { label: translate('change-location:top'), icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => { window.scrollTo(0, 0) } },
                        { label: 'Itens Selecionados', icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => setOpenItensModal(true) },
                        {
                            label: translate('truck-kanban:addMvi'), icon: <i className="mdi mdi-publish" />, onClick: () => validateCreateMvi(() => props.history.push({
                                pathname: `./createMvi`,
                                state: { hasJourney: true },
                                ...props
                            }))
                        },
                        { label: translate('truck-kanban:withoutJourney'), icon: <i className="mdi mdi-publish" />, color: '#8195a3', onClick: () => { messageModal.current.show() } },
                    ]}
                />
            }

        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        labels: state.truckKanbanReducer.labels
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLabelsPaged: (filter, callback) => {
            dispatch(TruckKanbanService.getLabelsPaged(filter, callback));
        },
        getLabelsCim: (filter, callback) => {
            dispatch(TruckKanbanService.getLabelsCimComposer(filter, callback));
        },
        getReport: (filter, callback) => {
            dispatch(TruckKanbanService.getReportSpaceXD(filter, callback));
        },
        addMviItem: (mviItem) => {
            dispatch(TruckKanbanService.addMviItem(mviItem));
        },
        createMvi: (mvi, callback) => {
            dispatch(TruckKanbanService.createMvi(mvi, callback));
        },
        addLabel: (label) => {
            dispatch(TruckKanbanService.addLabel(label));
        },
        removeLabel: (label) => {
            dispatch(TruckKanbanService.removeLabel(label));
        },
        clearLabel: () => {
            dispatch(TruckKanbanService.clearLabel());
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SpaceXD));